import { render, staticRenderFns } from "./MileageRule.vue?vue&type=template&id=81fb57fc&scoped=true"
import script from "./MileageRule.vue?vue&type=script&setup=true&lang=js"
export * from "./MileageRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MileageRule.vue?vue&type=style&index=0&id=81fb57fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fb57fc",
  null
  
)

export default component.exports